import { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Context } from "../../../../../store/store";
import { BottomBar } from "../../components/bottom-bar";
import Button from "../../components/button";
import { StoreContextType } from "@/store/types";
import { DtoTestSet } from "@/types/dto-types";
import { useUrlState } from "../../hooks";
import { Module } from "../../../../../constants";

import "./../TestSet/styles.scss";

export function TestSetIntro() {
  const [state] = useContext<StoreContextType>(Context as any);
  const {
    subPage: testSetId,
    navigateToParticipationPage,
    module,
  } = useUrlState();
  const { t } = useTranslation();

  const currentSet = useMemo(() => {
    const testSets =
      module === Module.Reflection
        ? state.publicTest.reflectionTestSets
        : state.publicTest.sets;

    return testSets.find(set => set._id === testSetId) as DtoTestSet;
  }, [testSetId, state, module]);

  function handleTestSetIntroNextClick() {
    navigateToParticipationPage({
      subPage: testSetId,
      subStep: currentSet.items[0]._id,
    });
  }

  return (
    <div className="tg_set-page tg_page tg_page-layout">
      <div className="tg_main tg_column">
        <div
          className="tg_info tg_test-set-info tg_test-info"
          dangerouslySetInnerHTML={{
            __html: currentSet.info.infoParticipation,
          }}
        />
      </div>
      <div className="tg_column">
        <Button
          className="start-survey-btn"
          large
          next
          onClick={handleTestSetIntroNextClick}
        >
          {state.publicTest.entries.length > 0
            ? t("frontend.test.nextTestSetButtonText", "Next")
            : t("frontend.test.startTestSetButtonText", "Start Survey")}
        </Button>
      </div>
      <BottomBar />
    </div>
  );
}
